import * as Yup from 'yup';
import checkoutFormModel from './checkoutFormModel';
const {
  formField: {
    firstName,
    address1,
    city,
    zipcode,
    state,
    nameOnCard,
    cardNumber,
    cvv,
    expiryDate,
    paymentMethod,
    plan
  }
} = checkoutFormModel;

export default [
  // Etapa 0: Validação de Plano
  Yup.object().shape({
    plan: Yup.string()
      .required('Por favor, selecione um plano de assinatura')
  }),
  // Etapa 1: Validação de Dados e Pagamento
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
    [zipcode.name]: Yup.string()
      .required(`${zipcode.requiredErrorMsg}`),
    [address1.name]: Yup.string()
      .required('O endereço é obrigatório'),
    [city.name]: Yup.string()
      .required('A cidade é obrigatória'),
    [state.name]: Yup.string()
      .required('O estado é obrigatório'),
    [paymentMethod.name]: Yup.string()
      .required(`${paymentMethod.requiredErrorMsg}`),
    [cardNumber.name]: Yup.string()
      .when(paymentMethod.name, {
        is: 'credit_card',
        then: Yup.string()
          .required(`${cardNumber.requiredErrorMsg}`)
          .matches(/^[0-9]{13,19}$/, `${cardNumber.invalidErrorMsg}`)
      }),
    [nameOnCard.name]: Yup.string()
      .when(paymentMethod.name, {
        is: 'credit_card',
        then: Yup.string()
          .required(`${nameOnCard.requiredErrorMsg}`)
      }),
    [expiryDate.name]: Yup.string()
      .when(paymentMethod.name, {
        is: 'credit_card',
        then: Yup.string()
          .required(`${expiryDate.requiredErrorMsg}`)
          .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, `${expiryDate.invalidErrorMsg}`)
      }),
    [cvv.name]: Yup.string()
      .when(paymentMethod.name, {
        is: 'credit_card',
        then: Yup.string()
          .required(`${cvv.requiredErrorMsg}`)
          .matches(/^[0-9]{3,4}$/, `${cvv.invalidErrorMsg}`)
      })
  }),
  // Etapa 2: Revisão (sem validação adicional)
  Yup.object().shape({})
];
